import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import {DomainManagerModule} from './domain-manager/domain-manager.module'
import {ProjectGroupsModule} from './project-groups/project-groups.module'
import {AdvancedManagementComponent} from './advancedManagement-ang7'
import { OidcModule } from './oidc-configuration/oidc.module';

@NgModule({
    imports: [SharedModule,DomainManagerModule,ProjectGroupsModule,OidcModule],
    declarations: [
        AdvancedManagementComponent
    ],
    entryComponents: [AdvancedManagementComponent],
    exports: [AdvancedManagementComponent]
})
export class AdvancedManagementModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/advancedManagement.module.ts